import { render, staticRenderFns } from "./products.vue?vue&type=template&id=349d84c4&"
import script from "./products.vue?vue&type=script&lang=ts&"
export * from "./products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349d84c4')) {
      api.createRecord('349d84c4', component.options)
    } else {
      api.reload('349d84c4', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=349d84c4&", function () {
      api.rerender('349d84c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/products.vue"
export default component.exports